import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';
import StyledTooltip from '../Tooltip/styles';

export const StyledPlanRow = styled.div`
  display: flex;
  align-items: center;
  padding-top: ${themeGet('spacing.spacingSm')};
  padding-bottom: 10px;
  color: ${themeGet('color.colorWhite')};
  line-height: 1.25;

  &.plan-row-header {
    display: flex;
    align-items: flex-end;
    width: 100%;
    margin-bottom: ${themeGet('scale.scaleUp03')};
    border-bottom: 2px solid ${themeGet('color.colorWhite')};
  }

  .compare {
    margin-left: -32px;
    color: ${themeGet('color.colorGrayBlue60')};
  }

  p {
    margin: 0;
  }

  strong  {
    color: ${props => props.modalIsOpen ? null : themeGet('color.colorWhite')};
  }

  ${StyledTooltip} {
    [role='tooltip']::after {
      border-color: ${themeGet('color.colorWhite')} transparent transparent
        transparent;
    }

    [role='tooltip'] > div {
      color: ${themeGet('color.colorBlueDarkest')};
      background-color: ${themeGet('color.colorWhite')};
    }
  }
`;

export const StyledPlanColumn = styled.div`
  min-width: 200px;
  color: ${themeGet('color.colorWhite')};

  &:first-of-type {
    flex: 2;
    padding-left: ${themeGet('scale.scaleUp05')};
  }

  h4 {
    margin: 0;
    color: ${props => props.modalIsOpen ? null : themeGet('color.colorWhite')};
  }

  i {
    font-size: ${themeGet('scale.scaleDown02')};
  }

  > div {
    margin: 0 auto;
  }

  > small {
    font-size: ${themeGet('scale.scaleDown01')};
    max-width: 160px;
    display: inline-block;
  }

  .with-footnote {
    position: relative;
    width: ${themeGet('scale.scaleBase')};
    margin: 0 auto;

    sup {
      position: absolute;
      top: 0;
      right: 0;
      transform: translateX(calc(100% + ${themeGet('scale.scaleDown04')}));
    }
  }

  ${StyledTooltip} .tooltip-text {
    border-color: ${themeGet('color.colorWhite')};
  }

  @media (max-width: 1400px) {
    ${StyledTooltip} {
      [role='tooltip'] {
        left: 0;
        justify-content: flex-start;
        transform: translate(0, calc(-100% - 15px));
      }

      [role='tooltip']::after {
        right: auto;
        left: 15px;
      }
    }
  }
`;

export const StyledPlanHeader = styled.div`
  h2,
  h5,
  p,
  a {
    color: ${themeGet('color.colorWhite')};
  }
  p {
    margin: 0;
  }
`;

export const StyledFootnote = styled.div`
  font-size: ${themeGet('scale.scaleDown01')};

  p {
    margin: 0;
  }
`;

export const StyledFeatureSection = styled.div`
  margin-bottom: ${themeGet('scale.scaleUp02')};

  > div:nth-of-type(2n + 2) {
    background-color: ${themeGet('color.colorGrayBlue90')};
  }

  .plan-modal & > div:nth-of-type(2n + 2) {
    background-color: ${themeGet('color.colorGrayBlue20')};
  }
`;

export const StyledBlueGradient = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 50%;
  background-image: linear-gradient(
    to bottom,
    rgba(0, 23, 62, 0),
    ${themeGet('color.colorGrayBlue100')}
  );
  pointer-events: none;
`;
